import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import routeNames from "../../router/routeNames";
import { getMyProjects } from "../../services/projectService";
import { ProjectListItem } from "../../types";

import ProjectSelectionPage from "../components/pages/projectSelectionPage";

const AdditionalHoursStartScreen = () => {
  const navigate = useNavigate();
  const [projects, setProjects] = useState<ProjectListItem[]>();
  const [searchTerm, setSearchTerm] = useState<string>("");

  useEffect(() => {
    async function fetchUserProjects() {
      const projects = await getMyProjects(searchTerm);

      const projectList: ProjectListItem[] = projects.data.result;
      if (projectList && projectList.length === 1 && searchTerm == "") {
        navigate(`${routeNames.additional_hours}/${projectList[0].id}`);
      } else {
        setProjects(projectList);
      }
    }

    fetchUserProjects();
  }, [navigate, searchTerm]);

  return (
    <ProjectSelectionPage
      projects={projects}
      buttonText="Open additional requests"
      pageTitle="Project overview"
      onProjectSelection={(id) =>
        navigate(`${routeNames.additional_hours}/${id}`)
      }
      onHandleSearch={(val) => {
        setSearchTerm(val);
      }}
    />
  );
};

export default AdditionalHoursStartScreen;
